import React from 'react';
import Description from '../Description';
import Title from '../Title';

const Slider = (props: any) => {

  const { imgLink, title, subTitle, desc } = props

  return (
    <div className='slider-box'>
      <div className='slider-right-box'>
        <img src={imgLink} alt={title || "Slider image"} />
        <div className='slider-title'>
          <Title
            textAlign="center"
            textColor="#fff"
            fontSize="50px"
            fontWeight="700"
            content={title}
          />
        </div>

        <div className='slider-subtitle'>
          <Title
            textAlign="center"
            textColor="#fff"
            fontSize="24px"
            fontWeight="600"
            content={subTitle}
          />
        </div>
        <div className="slider-desc">
          <Description
            textColor="#fff"
            textAlign="center"
            content={desc}
          />
        </div>
      </div>
    </div>
  );
}

export default Slider